import React, {useCallback} from "react";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import {postUserIdentity} from "../../service";
import {useHistory} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";


function UserInfoInputCard() {

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        idNumber: string
    }>();

    const userData = useUserInfo();

    const loading = useLoading()

    const { goBack } = useHistory()

    const dispatch = useDispatch()

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (userData && typeof values.idNumber === 'string') {
                    postUserIdentity({
                        userId: userData.id,
                        identity: values.idNumber
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess(null,() => {
                                goBack()
                            })
                            dispatch(userInfoAction(Object.assign({},userData,{idNumber:values.idNumber})))
                            // setUserStorage('idNumber',values.idNumber)
                            // his.goBack()
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }

            })
            .catch(e => console.error(e.message));
    }, [values])

    return <div className="user-nickname">
        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('idNumber', {
                    rules: [{required: true, message: '请输入身份证号码'}]
                })(<Input label='身份证号码' type={'text'} placeholder='请输入身份证号码'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                userData && <button type={'submit'} className="common-btn submit">确认</button>
            }

        </form>
    </div>
}

export default UserInfoInputCard;
